import type { KpiType } from "./generated/healthSmall.gen";

export const enum KpiEventType {
  Failure = 0,
  ImpliedUsageFailure = 1,
  ImpliedUsageSuccess = 2,
  Success = 3,
  Usage = 4
}

// Use single character field names to minimize code size since this is internal only
export interface Kpi {
  k: string;
  t: KpiType;
  a: boolean;
  o?: string;
}
